import { render, staticRenderFns } from "./YearFilter.vue?vue&type=template&id=4bb12106"
import script from "./YearFilter.vue?vue&type=script&lang=js"
export * from "./YearFilter.vue?vue&type=script&lang=js"
import style0 from "./YearFilter.vue?vue&type=style&index=0&id=4bb12106&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports